import {
  calculateAmount,
  calculateArray,
} from "../../helper-payroll/HelperFunction";
export const getmodifiedTable = (args) => {
  const { newTableObject, isMultipleRows, isRemoved, mandatoryFormula, caseName } = args;
  if (!Array.isArray(newTableObject)) return [];

  return newTableObject.map((row) => {
    const commonFields = [];
    const additionalFields = isMultipleRows
      ? [
          "overpaymentBasic",
          "overpaymentPeraAda",
          "tax",
          "excessAirportDuties",
          "OfDutyForCiaMciaBinocRangeTo1519",
          "pagibig",
          "phic",
          "apRate",
          "overpayment",
          "flagRaising",
          "noOfDays",
          "3",
          "2",
          "5",
          "10",
        ]
      : [];

    const fieldsToExtend = [...additionalFields, ...commonFields];

    fieldsToExtend.forEach((field) => {
      if (!(field in row)) return;

      // Special handling for isTwelvethCase with apRate - keep as number, not array
      const isTwelvethCaseApRate = caseName === "isTwelvethCase" && field === "apRate";

      if (!isTwelvethCaseApRate && !Array.isArray(row[field])) {
        row[field] = [];
      }
      const shouldCompute =
        commonFields.includes(field) && Array.isArray(row.basicRateForBackPay);

      if (shouldCompute) {
        const expression = mandatoryFormula[field] || "0";
        const { basicRateForBackPay, daysInAMonth, gsisInsuredDays } = row;
        const computedValues = row.basicRateForBackPay.map((rate) =>
          calculateAmount(expression, rate)
        );

        const gsis = calculateArray(basicRateForBackPay, [
          { type: "*", value: gsisInsuredDays },
          { type: "/", value: daysInAMonth },
          { type: "*", value: 0.09 },
        ]);

        row[field] = computedValues;
        row["gsisLR"] = gsis;
      } else if (isMultipleRows) {
        if (isRemoved) {
          // For isTwelvethCase with apRate, skip array removal logic
          if (!isTwelvethCaseApRate) {
            const lastIndex = [...row[field]]
              .reverse()
              .findIndex((val) => val === 0 || val === "");
            if (lastIndex !== -1) {
              row[field].splice(row[field].length - 1 - lastIndex, 1);
            }
          }
        } else {
          let defaultValue;

          if (
            field === "noOfDays" ||
            field === "OfDutyForCiaMciaBinocRangeTo1519"
          ) {
            defaultValue = 22;
          } else if (field === "apRate") {
            defaultValue = row?.payCode ?? 0; // fallback to 0 if payCode is undefined
          } else {
            defaultValue = 0;
          }

          // For isTwelvethCase with apRate, set as number directly (not array)
          if (isTwelvethCaseApRate) {
            row[field] = defaultValue;
          } else {
            row[field].push(defaultValue);
          }
        }
      }

      if (!isMultipleRows && isRemoved) {
        const fieldsToCheck = [
          "overpaymentBasic",
          "overpaymentPeraAda",
          "tax",
          "pagibig",
          "phic",
          "OfDutyForCiaMciaBinocRangeTo1519",
          "overpayment",
          "flagRaising",
          "apRate",
          "noOfDays",
          "3",
          "2",
          "5",
          "10",
        ];

        fieldsToCheck.forEach((fieldName) => {
          // Skip array logic for isTwelvethCase with apRate
          const isTwelvethCaseApRateField = caseName === "isTwelvethCase" && fieldName === "apRate";
          if (isTwelvethCaseApRateField) return;

          const currentArray = row[fieldName] ?? [];

          const isSpecial22 =
            fieldName === "noOfDays" ||
            fieldName === "OfDutyForCiaMciaBinocRangeTo1519";

          const isSpecialApRate = fieldName === "apRate";

          const lastIndex = [...currentArray].reverse().findIndex((val) => {
            if (val === 0 || val === "") return true;

            if (isSpecial22 && val === 22) return true;

            if (isSpecialApRate && val === row?.payCode) return true;

            return false;
          });

          if (lastIndex !== -1) {
            row[fieldName] = [];
          }
        });
      }
    });

    return row;
  });
};
